module.exports = __webpack_public_path__ + "img/l_ca.15786fec.png";